import ModelContainer from '@/modules/neovehicle/pages/classification/model/container.page.vue';
import FamilyContainer from '@/modules/neovehicle/pages/classification/family/container.page.vue';
import ModelList from '@/modules/neovehicle/pages/classification/model/list.page.vue';
import ModelForm from '@/modules/neovehicle/pages/classification/model/form.page.vue';
import FamilyList from '@/modules/neovehicle/pages/classification/family/list.page.vue';
import FamilyForm from '@/modules/neovehicle/pages/classification/family/form.page.vue';
import LastClassification from '@/modules/neovehicle/pages/last-classification.page.vue';

import { tabs } from './models';


export const neovehicleRoutes = [
  {
    path: `${process.env.BASE_URL}neovehicle`,
    component: () => import('@/layout/default.layout.vue'),
    children: [
      {
        path: 'model',
        component: ModelContainer,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            components: {
              [tabs.list]: ModelList,
            },
          },
          {
            path: tabs.form,
            components: {
              [tabs.form]: ModelForm,
            },
          },
        ],
      },
      {
        path: 'family',
        component: FamilyContainer,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            components: {
              [tabs.list]: FamilyList,
            },
          },
          {
            name: 'family_form',
            path: tabs.form,
            components: {
              [tabs.form]: FamilyForm,
            },
          },
        ],
      },
      {
        path: 'lastclassification',
        component: LastClassification,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
